import { Skeleton } from '../../base/Skeleton';
import styles from './LinkItemSkeleton.module.css';

export const LinkItemSkeleton = () => {
  return (
    <div className={styles.item}>
      <div className={styles.content}>
        <Skeleton width="70%" height={18} />
        <div className={styles.meta}>
          <Skeleton width={100} height={12} />
          <Skeleton width={60} height={12} />
        </div>
      </div>
      <div className={styles.actions}>
        <Skeleton variant="circular" width={32} height={32} />
      </div>
    </div>
  );
};


